import * as React from 'react';
import * as DotStyles from './DotDotDotField.scss';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { EventGroup } from '@uifabric/utilities';

export interface IDotDotDotFieldProps {
  onClick: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  /** aria label of the field. */
  ariaLabel?: string;
  title?: string;
}

export interface IDotDotDotFieldState {
  isExpanded: boolean;
}

export class DotDotDotField extends React.PureComponent<IDotDotDotFieldProps, IDotDotDotFieldState> {
  private _events: EventGroup;

  constructor(props: IDotDotDotFieldProps) {
    super(props);

    this.state = {
      isExpanded: false
    };
    this._events = new EventGroup(this);
    if (this._events) {
      this._events.on(document, 'DocLibContextMenuDismissed', () => {
        this.setState({ isExpanded: false });
      });
    }
  }

  public componentWillUnmount(): void {
    if (this._events) {
      this._events.dispose();
    }
  }

  public render(): JSX.Element | null {
    let { isDisabled, ariaLabel, title } = this.props;

    if (!isDisabled) {
      isDisabled = false;
    }
    return (
      <IconButton
        className={ `${DotStyles.heroButton}` }
        onClick={ this._onClickDot }
        aria-label={ ariaLabel }
        aria-expanded={ this.state.isExpanded }
        aria-haspopup='true'
        data-automationid='FieldRender-DotDotDot'
        iconProps={
          { iconName: 'MoreVertical' }
        }
        title={ title }
      />
    );
  }

  private _onClickDot = (ev: React.MouseEvent<HTMLButtonElement>) => {
    this.props.onClick(ev);
    this.setState({ isExpanded: true });
  }
}
